import { render, staticRenderFns } from "./SmartPostConfiguration.vue?vue&type=template&id=2064167a&scoped=true&"
import script from "./SmartPostConfiguration.vue?vue&type=script&lang=js&"
export * from "./SmartPostConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SmartPostConfiguration.vue?vue&type=style&index=0&id=2064167a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064167a",
  null
  
)

export default component.exports